import AgendaKatomi from "./Calendar";

const Planning: React.FC = (props) =>{


  return <AgendaKatomi {...props} />;
}

export default Planning 